(() => {
 const boot = (mountedRoot) => {
  const template = document.querySelector('[data-nt-media-toolbar-template]');
  const root = mountedRoot || document.querySelector('[data-nt-product]');
  if (!template || !root) return;
  const gallery = root.querySelector('.nt-pdp__main-image');
  const track = root.querySelector('[data-nt-gallery-thumbs]');
  if (!gallery || gallery.querySelector('.nt-media-toolbar')) return;
  const fragment = template.content.cloneNode(true);
  const toolbar = fragment.querySelector('.nt-media-toolbar');
  const zoomDialog = fragment.querySelector('dialog');
  gallery.append(toolbar);
  document.body.append(zoomDialog);
  const photos = () => track ? [...track.querySelectorAll('[data-nt-product-thumb]:not([data-nt-360-thumb])')] : [];
  root.querySelectorAll('[data-nt-gallery-prev],[data-nt-gallery-next]').forEach(button => {
   button.addEventListener('click', event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    const items = photos();
    if (items.length < 2) return;
    const current = Math.max(0, items.findIndex(item => item.classList.contains('is-active')));
    const delta = button.hasAttribute('data-nt-gallery-next') ? 1 : -1;
    items[(current + delta + items.length) % items.length].click();
   }, true);
  });
  const rotate = () => track?.querySelector('[data-nt-360-thumb]');
  const galleryButton = toolbar.querySelector('[data-nt-media-gallery]');
  const rotateButton = toolbar.querySelector('[data-nt-media-rotate]');
  const position = toolbar.querySelector('[data-nt-media-position]');
  gallery.append(position);
  const zoomContent = zoomDialog.querySelector('.nt-media-zoom-content');
  let lastPhoto = 0;
  let movedStage = null;
  const viewer = document.querySelector('[data-nt-360-viewer]');
  const frameImage = document.querySelector('[data-nt-360-image]');
  if (viewer && frameImage) {
   const poster = new Image();
   poster.className = 'nt-media-360-poster';
   poster.alt = frameImage.alt;
   const updatePoster = () => { poster.src = frameImage.currentSrc || frameImage.src; };
   updatePoster();
   frameImage.addEventListener('load', updatePoster);
   viewer.append(poster);
  }
  const sync = () => {
   const model = rotate();
   const in360 = !!model?.classList.contains('is-active');
   galleryButton.setAttribute('aria-pressed', String(!in360));
   rotateButton.hidden = !model;
   rotateButton.setAttribute('aria-pressed', String(in360));
   position.hidden = in360;
   const items = photos();
   position.hidden = in360 || items.length < 2;
   galleryButton.parentElement.hidden = !model && items.length < 2;
   const index = items.findIndex(item => item.classList.contains('is-active'));
   if (index >= 0) lastPhoto = index;
   const value = String(lastPhoto + 1).padStart(2, '0') + ' / ' + String(items.length).padStart(2, '0');
   if (position.textContent !== value) position.textContent = value;
   if (in360) {
    const start = gallery.querySelector('[data-nt-360-start]');
    if (start && start.getAttribute('aria-pressed') !== 'true' && matchMedia('(max-width:767px)').matches) start.click();
   }
  };
  galleryButton.addEventListener('click', () => { photos()[Math.min(lastPhoto, photos().length - 1)]?.click(); sync(); });
  rotateButton.addEventListener('click', () => {
   const model = rotate();
   if (!model) return;
   model.click();
   if (!model.classList.contains('is-active')) {
    track.querySelectorAll('[data-nt-product-thumb]').forEach(item => {
     item.classList.toggle('is-active', item === model);
     item.setAttribute('aria-pressed', String(item === model));
    });
   }
   requestAnimationFrame(sync);
  });
  toolbar.addEventListener('click', event => event.stopPropagation());
  root.querySelectorAll('[data-nt-thumbs-prev],[data-nt-thumbs-next]').forEach(button => {
   const next = button.hasAttribute('data-nt-thumbs-next');
   button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="' + (next ? 'm9 5 7 7-7 7' : 'm15 5-7 7 7 7') + '"/></svg>';
   button.addEventListener('click', event => {
    event.preventDefault(); event.stopImmediatePropagation();
    const vertical = matchMedia('(min-width:821px)').matches;
    button.setAttribute('aria-label', (next ? 'Scroll thumbnails ' : 'Scroll thumbnails ') + (vertical ? (next ? 'down' : 'up') : (next ? 'right' : 'left')));
    track.scrollBy({ [vertical ? 'top' : 'left']: (next ? 1 : -1) * (vertical ? track.clientHeight : track.clientWidth) * .8, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
   }, true);
  });
  toolbar.querySelector('[data-nt-media-zoom]').addEventListener('click', () => {
   if (rotate()?.classList.contains('is-active')) {
    movedStage = gallery.querySelector('[data-nt-360-stage]');
    if (movedStage) zoomContent.replaceChildren(movedStage);
   } else {
    const original = gallery.querySelector('[data-nt-main-image]');
    const image = new Image();
    image.src = original.currentSrc || original.src;
    image.alt = original.alt;
    zoomContent.replaceChildren(image);
   }
   zoomDialog.showModal();
  });
  zoomDialog.querySelector('[data-nt-media-close]').addEventListener('click', () => zoomDialog.close());
  zoomDialog.addEventListener('close', () => {
   if (movedStage) { gallery.append(movedStage); movedStage = null; }
   zoomContent.replaceChildren();
  });
  zoomDialog.addEventListener('click', event => {
   if (event.target !== zoomDialog) return;
   const rect = zoomDialog.getBoundingClientRect();
   if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) zoomDialog.close();
  });
  const observer = new MutationObserver(sync);
  if (track) observer.observe(track, { subtree:true, childList:true, attributes:true, attributeFilter:['class'] });
  root.addEventListener('nt:product:unload', () => {
   observer.disconnect();
   if (movedStage) gallery.append(movedStage);
   zoomDialog.remove();
  }, {once:true});
  sync();
 };
 document.addEventListener('nt:product:mount', event => {
  if (event.target.matches?.('[data-nt-product]')) boot(event.target);
 });
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
})();


